const redirectViaSubmit = (url: string, method: string) => {
  const form = document.createElement('form');

  form.method = 'POST';
  form.action = url;

  // Place in top-left corner of screen regardless of scroll position.
  form.style.position = 'fixed';
  form.style.top = '0';
  form.style.left = '0';

  // Ensure it has a small width and height. Setting to 1px / 1em
  // doesn't work as this gives a negative w/h on some browsers.
  form.style.width = '2em';
  form.style.height = '2em';

  // We don't need padding, reducing the size if it does flash render.
  form.style.padding = '0';

  // Clean up any borders.
  form.style.border = 'none';
  form.style.outline = 'none';
  form.style.boxShadow = 'none';

  // Avoid flash of white box if rendered for any reason.
  form.style.background = 'transparent';

  const methodInputElement = document.createElement('input');
  methodInputElement.type = 'hidden';
  methodInputElement.name = '_method';
  methodInputElement.value = method;

  form.appendChild(methodInputElement);

  document.body.appendChild(form);
  form.submit();
};

export default redirectViaSubmit;
